import { render, staticRenderFns } from "./LanguageController.vue?vue&type=template&id=147c426c"
import script from "./LanguageController.vue?vue&type=script&lang=js"
export * from "./LanguageController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports